'use client';

import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '@/components/Typography';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
import { motionPopLayout } from '@/styles/motionAnimations';

export type PromoCodeProps = {
    className?: string;
    code?: string;
};

export function PromoCode({ className, code }: PromoCodeProps) {
    const [copied, setCopied] = useState<boolean>(false);
    const timeoutRef = useRef<NodeJS.Timeout>(undefined);
    useEffect(
        () => () => {
            clearTimeout(timeoutRef.current);
        },
        []
    );

    const copy = async () => {
        if (!code) {
            return;
        }

        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                setCopied(false);
            }, 4000);
        } catch (error) {
            console.error(error);
        }
    };

    if (!code) {
        return null;
    }

    return (
        <button className={cn('inline-flex bg-white rounded-box p-1 gap-2 text-base-content items-center w-full md:w-94 justify-between', className)} onClick={copy}>
            <Typography variant="paragraph" className="flex-grow-1 items-center pl-5 text-left max-w-58 md:max-w-60 overflow-hidden">
                Promo:
                <span className="font-bold px-2">{code}</span>
            </Typography>
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.span key={copied ? 'copied' : 'copy'} className="btn btn-primary px-7.5 py-6" {...motionPopLayout}>
                    {copied ? (
                        <span>Copied!</span>
                    ) : (
                        <>
                            <PhosphorIcon name="copy" />
                            <span>Copy</span>
                        </>
                    )}
                </motion.span>
            </AnimatePresence>
        </button>
    );
}
